import React from 'react';
import PropTypes from 'prop-types';

import withMedia from '~/modules/core/utils/mediaHelpers/withMedia';

import { ProductDetailsTitle } from '~/modules/ecommerceCoreUI/components/basic/Labels';
import { Column } from '~/modules/coreUI/components/layouts/helpers/LinearLayout';
import ProductRating from './ProductRating';

const Title = props => (
  <Column leftAligned spaceBetween={1}>
    <ProductDetailsTitle media={props.media}>{props.title}</ProductDetailsTitle>
    <ProductRating rating={props.averageRating} ratingCount={props.ratingCount} {...props} />
  </Column>
);

Title.propTypes = {
  title: PropTypes.string.isRequired,
  media: PropTypes.shape({}).isRequired,
  averageRating: PropTypes.number.isRequired,
  ratingCount: PropTypes.number.isRequired,
};

export default withMedia(Title);
